import Restful from '../utils/restful.js'
const project = 'sci/'

const info = new Restful(project, 'info/page')

export default info
